import { formatPercentVariation } from "@/helpers/utils";

const TableRow = ({ index, item }) => {

    const isPercentVariationNegative = (value: number | null) => {
        if (value === null || value === undefined || value === 0) return 'table-data-default';
        return value < 0 ? 'table-data-lowest' : 'table-data-highest';
    };

    const priceIsntAvailable = (value: number | null) => {
        if (value === null || value === undefined || value === 0) return 'table-data-default';
    };


    return (

        <tr data-testid={`historic-prices-table-body-row-${index}`} key={index} className="table-row">
            <td data-testid="historic-prices-table-body-ref-month" className="table-data">{item.ref_month}</td>
            <td data-testid="historic-prices-table-body-fipe-price" className={`table-data  ${priceIsntAvailable(item.fipe_last_price)}`}>{item.fipe_last_price ?? 'Preço Indisponível'}</td>
            <td data-testid="historic-prices-table-body-fipe-variation" className={`table-data ${isPercentVariationNegative(item.fipe_price_percent_variation)}`}>
                {formatPercentVariation(item.fipe_price_percent_variation)}
            </td>
            <td data-testid="historic-prices-table-body-wm-price" className={`table-data  ${priceIsntAvailable(item.wm_last_price)}`}>{item.wm_last_price ?? 'Preço Indisponível'}</td>
            <td data-testid="historic-prices-table-body-wm-variation" className={`table-data ${isPercentVariationNegative(item.wm_price_percent_variation)}`}>
                {formatPercentVariation(item.wm_price_percent_variation)}
            </td>
        </tr>
    )
}

export default TableRow;